export const intialState={
    isLoading:false
}